import { callAPI } from "../../network/networkConnection";

const BASE_URL = process.env.REACT_APP_APIUrl + "admin";

/**
 * Get all roles
 */
export const getAllRoles = (includeInactive = false) => {
  return callAPI(
    `${BASE_URL}/roles?includeInactive=${includeInactive}`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Get role by ID
 */
export const getRoleById = (id) => {
  return callAPI(
    `${BASE_URL}/roles/${id}`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Create new role
 */
export const createRole = (data) => {
  return callAPI(
    `${BASE_URL}/roles`,
    "POST",
    { "Content-Type": "application/json" },
    JSON.stringify(data)
  );
};

/**
 * Update role
 */
export const updateRole = (id, data) => {
  return callAPI(
    `${BASE_URL}/roles/${id}`,
    "PUT",
    { "Content-Type": "application/json" },
    JSON.stringify(data)
  );
};

/**
 * Delete role
 */
export const deleteRole = (id) => {
  return callAPI(
    `${BASE_URL}/roles/${id}`,
    "DELETE",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Get available menu items
 */
export const getAvailableMenus = () => {
  return callAPI(
    `${BASE_URL}/roles/menus`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Assign role to user (roleId can be null to remove role)
 */
export const assignRoleToUser = (userId, roleId) => {
  return callAPI(
    `${BASE_URL}/roles/assign`,
    "POST",
    { "Content-Type": "application/json" },
    JSON.stringify({ userId, roleId: roleId || null })
  );
};

/**
 * Get users by role
 */
export const getUsersByRole = (roleId) => {
  return callAPI(
    `${BASE_URL}/roles/${roleId}/users`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Get sub-admin users
 */
export const getSubAdmins = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return callAPI(
    `${BASE_URL}/sub-admins?${queryString}`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Get seller users
 */
export const getSellers = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return callAPI(
    `${BASE_URL}/sellers?${queryString}`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Create sub-admin user
 */
export const createSubAdmin = (data) => {
  return callAPI(
    `${BASE_URL}/sub-admins`,
    "POST",
    { "Content-Type": "application/json" },
    JSON.stringify(data)
  );
};

export const roleService = {
  getAllRoles,
  getRoleById,
  createRole,
  updateRole,
  deleteRole,
  getAvailableMenus,
  assignRoleToUser,
  getUsersByRole,
  getSubAdmins,
  createSubAdmin,
  getSellers,
};
